import React from 'react'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Card from 'react-bootstrap/Card'

export default class LonelyCard extends React.Component { 

	getImageStyle()  {
		return {
			backgroundImage: `url(${this.props.image})`, 
			width:'100%', 
			height:'230px',
			backgroundSize: 'cover',
			backgroundPosition: 'center'
		}
	}

	render() { 
		return (
			<Card style={{...this.props.style}}> 
				<Row style={{flex: 1}}>
					<Col md={12} 
								className={this.props.className}
								onClick={() => this.props.onClick()}>
									<div style={this.getImageStyle()}/>
								</Col>
					<Col md={12}>
						{this.props.children}
					</Col>
				</Row>
		</Card>)
	}
}
